// AeflorInscricao.jsx
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from '../../services/api.js';
import Menu from "../../comum/Menu/index.jsx";
import Footer from "../../comum/Footer/index.jsx";
import SweetAlert from 'react-bootstrap-sweetalert';

// --- Componente Item de Ingresso ---
const IngressoItem = ({ ingresso, inscrito, CadastrarIngresso, ConfirmaApagarIngresso, toggleTransporte }) => {

    const formatNumber = (amount, decimalCount = 2, decimal = ",", thousands = ".") => {
        try {
            decimalCount = Math.abs(decimalCount);
            decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

            const negativeSign = amount < 0 ? "-" : "";
            let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
            let j = (i.length > 3) ? i.length % 3 : 0;

            return negativeSign +
                (j ? i.substr(0, j) + thousands : '') +
                i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) +
                (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
        } catch {
            return '0,00';
        }
    };

    const estaInscrito = ingresso.conf !== null;
    const isPrincipal = ingresso.codtipo === 0;

    let corBotaoAcao = 'primary';
    let iconeBotaoAcao = 'fa-check';
    let textoBotaoAcao = 'Inscrever';
    let manipuladorAcao = () => CadastrarIngresso(ingresso.codingresso, ingresso.codtipo);

    if (estaInscrito) {
        corBotaoAcao = 'danger';
        iconeBotaoAcao = 'fa-trash-alt';
        textoBotaoAcao = 'Excluir';
        manipuladorAcao = () => ConfirmaApagarIngresso(ingresso.codingresso, ingresso.nome);
    } else if (!isPrincipal && inscrito === 0) {
        corBotaoAcao = 'secondary';
        iconeBotaoAcao = 'fa-times';
        textoBotaoAcao = 'Aguarde';
        manipuladorAcao = null;
    }

    const transporteIcone = ingresso.transporte === 'S'
        ? <i className="fas fa-bus text-primary me-2" title="Transporte Incluído"></i>
        : <i className="fas fa-route text-muted me-2" title="Transporte Não Solicitado"></i>;

    return (
        <div className={`card mb-3 shadow-sm ${estaInscrito ? 'border-success' : 'border-light'}`}>
            <div className="card-body p-3">
                <div className="d-flex justify-content-between align-items-center">
                    <div>
                        <h5 className="card-title mb-1">{ingresso.nome}</h5>
                        <p className={`card-text mb-0 badge ${isPrincipal ? 'bg-info' : 'bg-warning text-dark'}`}>
                            {isPrincipal ? ingresso.tipo : `${ingresso.tipo} (${ingresso.idade} anos)`}
                        </p>
                    </div>

                    <div className="text-end">
                        <p className="fw-bold mb-0 text-success">
                            R$ {formatNumber(ingresso.valor)}
                        </p>
                        <small className="text-muted">
                            {ingresso.transporte === 'S' && estaInscrito && `(+R$ ${formatNumber(ingresso.valort)})`}
                        </small>
                    </div>
                </div>

                <div className="d-flex justify-content-between align-items-center mt-2 pt-2 border-top">
                    <div>
                        {estaInscrito && transporteIcone}
                        <span className={`badge ${estaInscrito ? 'bg-success' : 'bg-secondary'}`}>
                            {estaInscrito ? 'Confirmado' : 'Disponível'}
                        </span>
                    </div>

                    <div className="d-flex gap-2">
                        {isPrincipal && (
                            <button
                                type="button"
                                className={`btn btn-sm ${ingresso.transporte === 'S' ? 'btn-success' : 'btn-outline-warning'}`}
                                onClick={() => toggleTransporte(ingresso.transporte === 'S' ? 'N' : 'S')}
                            >
                                {ingresso.transporte === 'S'
                                    ? <><i className="fas fa-bus me-1"></i> Ônibus</>
                                    : <><i className="fas fa-plus me-1"></i> Adicionar Transporte</>
                                }
                            </button>
                        )}

                        {manipuladorAcao && (
                            <button
                                type="button"
                                onClick={manipuladorAcao}
                                className={`btn btn-sm btn-outline-${corBotaoAcao} ${!estaInscrito ? 'pulse btn-outline-success' : ''}`}
                                title={textoBotaoAcao}
                            >
                                <i className={`fas ${iconeBotaoAcao}`}></i> {textoBotaoAcao}
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};
// --- Fim Componente Item de Ingresso ---


function AeflorInscricao() {
    const [sucesso, setSucesso] = useState('');
    const [erro, setErro] = useState('');
    const [codIngresso, setCodIngresso] = useState('');
    const [nome, setNome] = useState('');
    const [tipo, setTipo] = useState('');
    const [valortransporte, setValorTransporte] = useState(0);
    const [datanascimento, setDataNascimento] = useState('');
    const [somavalor, setSomavalor] = useState(0);
    const [listaIngresso, setListaIngresso] = useState([]);
    const [mensagem, setMensagen] = useState('');
    const [aprovacao, setAprovacao] = useState(false);
    const [inscrito, setInscrito] = useState(0);
    const [tipodependente, setTipoDependente] = useState('');
    const navigate = useNavigate();

    const chapa = localStorage.getItem("chapa");
    const codevento = localStorage.getItem("codevento");

    useEffect(() => {
        if (!chapa) {
            navigate("/arbor/login");
            return;
        }
        if (!codevento) {
            navigate("/arbor/aeflor");
            return;
        }
        CarregarDadosIngresso();
    }, [chapa, codevento, navigate]);

    const formatNumber = (amount, decimalCount = 2, decimal = ",", thousands = ".") => {
        try {
            decimalCount = Math.abs(decimalCount);
            decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

            const negativeSign = amount < 0 ? "-" : "";
            let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
            let j = (i.length > 3) ? i.length % 3 : 0;

            return negativeSign +
                (j ? i.substr(0, j) + thousands : '') +
                i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) +
                (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
        } catch {
            return '0,00';
        }
    };

    function CarregarDadosIngresso() {
        api.get('/aeflor/evento/' + codevento + '/' + chapa)
            .then((retorno) => {
                const dados = retorno.data || [];

                // Definir dependente conforme tipo
                const dadosComDependente = dados.map(item => ({
                    ...item,
                    dependente:
                        item.codtipo === 0 ? 'FUNCIONARIO' :
                        item.codtipo === 1 ? 'CADASTRADO' :
                        item.dependente || 'MANUAL'
                }));

                setListaIngresso(dadosComDependente);
                setValorTransporte(0);

                const listaConfirmada = dadosComDependente.filter(ingresso => ingresso.conf !== null);

                const somaIngressos = listaConfirmada.reduce((acc, value) => acc + (value.valor || 0), 0);
                setSomavalor(somaIngressos);

                const somaTransporte = listaConfirmada
                    .filter(item => item.transporte === 'S')
                    .reduce((acc, value) => acc + (value.valort || 0), 0);
                setValorTransporte(somaTransporte);

                setInscrito(listaConfirmada.length);
            })
            .catch(err => console.error("Erro ao carregar dados do ingresso:", err));
    }

    function toggleTransporte(opcao) {
        api.post('/aeflor/transporte/' + codevento + '/' + chapa + '?transporte=' + opcao)
            .then(() => {
                CarregarDadosIngresso();
                setSucesso('S');
                setMensagen(opcao === 'S'
                    ? 'Transporte incluído para todos os dependentes! 🚌'
                    : 'Transporte removido de todos os dependentes! ❌'
                );
            })
            .catch((err) => {
                console.error(err);
                setErro('S');
                setMensagen('Falha ao alterar o transporte.');
            });
    }

    function CadastrarIngresso(numingresso, tipoIngresso) {
        let dependenteTipo = 'CADASTRADO';
        if (tipoIngresso === 0) dependenteTipo = 'FUNCIONARIO';

        api.post('/aeflor/evento/' + codevento + '/' + chapa + '/' + numingresso, { dependente: dependenteTipo })
            .then(() => {
                CarregarDadosIngresso();
                setSucesso('S');
                setMensagen('Ingresso cadastrado com sucesso! 🎉');
            })
            .catch(() => {
                setErro('S');
                setMensagen('Falha ao cadastrar o ingresso.');
            });
    }

    function ConfirmaApagarIngresso(numingresso, nomepessoa) {
        setAprovacao(true);
        setCodIngresso(numingresso);
        setNome(nomepessoa);
    }

    function ApagarIngresso(numingresso) {
        api.delete('/aeflor/evento/' + numingresso)
            .then(() => {
                CarregarDadosIngresso();
                setSucesso('S');
                setAprovacao(false);
                setMensagen('Ingresso excluído com sucesso! 🗑️');
            })
            .catch(() => {
                setErro('S');
                setAprovacao(false);
                setMensagen('Falha ao excluir o ingresso.');
            });
    }

    function zerarcampos() {
        setNome('');
        setTipo('');
        setDataNascimento('');
    }

    function CadastrarDependente() {
        if (!tipo || !nome || !datanascimento) {
            setErro('S');
            setMensagen('É necessário informar o nome, parentesco e data de nascimento do dependente!');
            return;
        }

        const data = {
            codevento,
            chapa,
            nome,
            tipo,
            datanascimento,
            dependente: 'MANUAL'
        };

        api.post('/aeflor/evento/' + codevento + '/' + chapa + '/DEPENDENTE', data)
            .then(() => {
                CarregarDadosIngresso();
                setSucesso('S');
                setMensagen('Dependente cadastrado com sucesso! ✅');
                zerarcampos();
            })
            .catch(error => {
                console.error(error);
                setErro('S');
                setMensagen('Falha no envio do dependente!');
            });
    }

    return (
        <>
            {/* Modal Cadastro Manual */}
            <div className="modal fade" id="modalDependente" tabIndex="-1" aria-labelledby="modalDependenteLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header bg-primary text-white">
                            <h5 className="modal-title" id="modalDependenteLabel">Incluir Dependente Manualmente</h5>
                            <button type="button" className="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close" onClick={zerarcampos}></button>
                        </div>
                        <div className="modal-body">
                            <div className="mb-3">
                                <label htmlFor="nomeDependente" className="form-label fw-bold">Nome completo:</label>
                                <input
                                    id="nomeDependente"
                                    type="text"
                                    onChange={(e) => setNome(e.target.value)}
                                    value={nome}
                                    className="form-control"
                                    placeholder="Ex: Maria da Silva"
                                />
                            </div>

                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <label htmlFor="tipoParentesco" className="form-label fw-bold">Parentesco:</label>
                                    <select
                                        id="tipoParentesco"
                                        className="form-select"
                                        onChange={(e) => setTipo(e.target.value)}
                                        value={tipo}
                                    >
                                        <option value="">Selecione uma opção</option>
                                        <option value="CÔNJUGE">CÔNJUGE</option>
                                        <option value="FILHO">FILHO(A)</option>
                                        <option value="ENTEADO">ENTEADO(A)</option>
                                        <option value="OUTROS">COMPANHEIRO(A)</option>
                                    </select>
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label htmlFor="dataNascimento" className="form-label fw-bold">Data de Nascimento:</label>
                                    <input
                                        id="dataNascimento"
                                        type="date"
                                        onChange={(e) => setDataNascimento(e.target.value)}
                                        className="form-control"
                                        value={datanascimento}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={zerarcampos}>
                                <i className="fas fa-times me-1"></i> Cancelar
                            </button>
                            <button type="button" className="btn btn-success" data-bs-dismiss="modal" onClick={CadastrarDependente}>
                                <i className="fas fa-plus-circle me-1"></i> Cadastrar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            {/* Fim Modal */}

            <Menu modulo="ARBOR" />

            <div className="container mt-5">
                <div className="row justify-content-center">
                    <div className="col-lg-8 mx-auto">
                        <div className="card shadow-lg border-0">
                            <div className="card-header bg-danger text-white text-center p-3">
                                <h3 className="mb-0">Inscrições 🎉</h3>
                                <p className="mb-0 small text-white"><i>Selecione seus ingressos e adicione dependentes.</i></p>
                            </div>
                            <div className="card-body p-4">
                                <div className="list-group">
                                    {listaIngresso.length > 0 ? (
                                        listaIngresso.map((ingresso) => (
                                            <IngressoItem
                                                key={ingresso.codingresso}
                                                ingresso={ingresso}
                                                inscrito={inscrito}
                                                CadastrarIngresso={CadastrarIngresso}
                                                ConfirmaApagarIngresso={ConfirmaApagarIngresso}
                                                toggleTransporte={toggleTransporte}
                                            />
                                        ))
                                    ) : (
                                        <div className="alert alert-warning text-center">
                                            Nenhum ingresso encontrado. 😔
                                        </div>
                                    )}
                                </div>

                                <hr className="my-4" />

                                <div className="d-flex flex-column flex-md-row justify-content-between align-items-center">
                                    {inscrito > 0 && (
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-outline-primary mb-2 mb-md-0 me-md-auto"
                                            data-bs-toggle="modal"
                                            data-bs-target="#modalDependente"
                                            onClick={zerarcampos}
                                        >
                                            <i className="fas fa-user-plus me-1"></i> Adicionar Não Cadastrado
                                        </button>
                                    )}

                                    <Link
                                        to={"/arbor/aeflor/"}
                                        className="btn btn-lg btn-success d-flex align-items-center justify-content-center"
                                    >
                                        Finalizar
                                        <span className="badge bg-light text-success ms-2 p-2 fs-6">
                                            R$ {formatNumber(somavalor)}
                                        </span>
                                    </Link>
                                </div>

                                {valortransporte > 0 && inscrito > 0 && (
                                    <div className="text-end mt-2">
                                        <small className="text-muted fw-bold">
                                            Transporte incluído: R$ {formatNumber(valortransporte)}
                                        </small>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {sucesso === 'S' && (
                <SweetAlert
                    success
                    confirmBtnText="OK"
                    onConfirm={() => setSucesso('')}
                    title="Sucesso"
                >
                    {mensagem}
                </SweetAlert>
            )}

            {erro === 'S' && (
                <SweetAlert
                    error
                    confirmBtnText="OK"
                    onConfirm={() => setErro('')}
                    title="Erro"
                >
                    {mensagem}
                </SweetAlert>
            )}

            {aprovacao && (
                <SweetAlert
                    warning
                    showCancel
                    confirmBtnText="Sim, Excluir"
                    cancelBtnText="Não, Cancelar"
                    onConfirm={() => ApagarIngresso(codIngresso)}
                    onCancel={() => setAprovacao(false)}
                    title="Confirmação de Exclusão"
                >
                    Deseja apagar o ingresso de <b>{nome}</b>?
                </SweetAlert>
            )}

            <Footer />
        </>
    );
}

export default AeflorInscricao;
